import React from 'react';
import { FormProvider, useForm, useWatch } from 'react-hook-form';
import { FilterEvent, FiltersDrover } from 'components/shared/Filters';

import { DealSheetRulesFilterType } from '../types';
import { initialDealSheetRulesFiltersValue } from '../constants';
import { componentCardToTypeMapper, DealSheetRulesFilters } from './cards';

interface Props {
  open: boolean;
  onClose: VoidFunction;
  onChanged: (filters: DealSheetRulesFilters, event: FilterEvent) => void;
}

export const DealSheetRulesTableFilter = ({ open, onClose, onChanged }: Props) => {
  const form = useForm<DealSheetRulesFilters>({ defaultValues: initialDealSheetRulesFiltersValue });
  const filtersValue = useWatch({ control: form.control }) as DealSheetRulesFilters;

  const handleApplyFilters = async () => {
    onClose();
    onChanged(filtersValue, { type: 'apply' });
  };

  const handleResetFilters = () => {
    form.reset();
    onClose();
    onChanged(initialDealSheetRulesFiltersValue, { type: 'reset' });
  };

  return (
    <FormProvider<DealSheetRulesFilters> {...form}>
      <FiltersDrover
        open={open}
        onClose={onClose}
        componentMap={componentCardToTypeMapper}
        actions={{ onReset: handleResetFilters, onApply: handleApplyFilters }}
        configuration={[
          DealSheetRulesFilterType.PAYMENT_TYPE,
          DealSheetRulesFilterType.CUSTOMER_TYPE,
          DealSheetRulesFilterType.EQUIPMENT_TYPE,
          DealSheetRulesFilterType.COUNTRY,
          DealSheetRulesFilterType.STATE,
          DealSheetRulesFilterType.PROVINCE,
        ]}
      />
    </FormProvider>
  );
};
